import Model from './model'

export default class Gallery extends Model {
  constructor() {
    super()
    this.hydrate({
      title: '',
      slug: '',
      active: false,
      images: [],
    })
  }
}
